export default "__VITE_ASSET__52e563e5__"